import React, { useEffect, useMemo } from 'react';
import { useDebouncedValue, useInputState } from '@mantine/hooks';
import useSWR from 'swr';
import { trpc } from '../../../../api/trpc';
import Select from 'react-select';

type Props = {
  placeholder?: string;
  selectedValue?: { name: string; code: string };
  onChangeSelectedValue: (value?: { name: string; code: string }) => void;
  name: string;
};

export const CustomsDeliveryFindByNameSelect = React.forwardRef(function (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  const [query, setQuery] = useInputState(props.selectedValue?.name || '');
  const [debouncedQuery] = useDebouncedValue(query, 500);
  const input = { search: debouncedQuery };
  const { data = [] } = useSWR(
    debouncedQuery ? ['customsDelivery.listCodes', input] : null,
    () => trpc.customsDelivery.listCodes.query(input),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
  const options = useMemo(() => {
    return data?.map((option) => ({
      value: option.code,
      label: option.name,
    }));
  }, [data]);

  const handleSelect = (item: { label: string; value: string }) => {
    setQuery(item.label);
    props.onChangeSelectedValue({
      name: item.label,
      code: item.value,
    });
  };

  useEffect(() => {
    if (props.selectedValue) {
      setQuery(props.selectedValue?.name);
    }
    return;
  }, []);

  return (
    <Select
      className={'w-100'}
      blurInputOnSelect={true}
      styles={{
        container: (base) => ({
          ...base,
          maxWidth: '100%',
        }),
        menu: (base) => ({
          ...base,
          maxWidth: '100%',
        }),
        input: (base) => ({
          ...base,
          maxWidth: '50px',
        }),
      }}
      formatOptionLabel={(option) => {
        return (
          <div>
            <div className="text-truncate ">{option.label}</div>
            <div className="text-truncate fs-14 color-gray-400">
              {option.value}
            </div>
          </div>
        );
      }}
      name={props.name}
      placeholder={props.placeholder}
      inputValue={query}
      onInputChange={(newValue) => {
        setQuery(newValue);
      }}
      filterOption={null}
      options={options}
      onChange={(value) => {
        if (value) {
          handleSelect(value);
        }
      }}
      //@ts-ignore
      ref={ref}
    />
  );
});
